import { PrintMenu } from '../print-menu';
import { Type } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { ProductMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/product-menu-footer.component';
import { EmptyMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/empty-menu-footer/empty-menu-footer.component';
import { PrintFooterLayoutType } from '../../enum/shared/print-footer-layout-type.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class OGKushPrintMenu extends PrintMenu {
  getThemeClass(): string {
    return 'og-kush-print-theme';
  }

  getPageBottomMargin(): string {
    return '0.5in';
  }

  getPageTopMargin(): string {
    return '0.5in';
  }

  getPageLeftMargin(): string {
    return '0.5in';
  }

  getPageRightMargin(): string {
    return '0.5in';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.FirstPage;
  }

  getPrintFooterLayoutType(): PrintFooterLayoutType {
    return this.menuOptions?.printFooterLayout || PrintFooterLayoutType.AllPagesHugging;
  }

  getPriceColumnTitle(col: SectionColumnViewModel): string {
    return super.getPriceColumnTitle(col).replace(/\b(g|mg|ml)\b/, x => x.toUpperCase());
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Rubik.Medium_500,
      FONT.Poppins.Regular_400,
      FONT.Poppins.Medium_500,
      FONT.Poppins.SemiBold_600,
      FONT.Poppins.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/xay1rsv.css';
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  override fixedLocationBadgesPropertyIsWithin(): WithinNameCell | null {
    return WithinNameCell.TitleLine;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getShowFooter(): boolean {
    return super.getShowFooter();
  }

  getFooterType(): Type<ProductMenuFooterComponent> {
    return EmptyMenuFooterComponent;
  }
}
